export default "/images/vendor/flag-icon-css/flags/4x3/cy.svg?70de54e68d8683969410788a726e35ec";